import React from 'react';

import { clsx } from 'clsx';

export type SpinnerProps = {
  className?: string;
};

export const Spinner: React.FC<SpinnerProps> = (props: SpinnerProps) => {
  return (
    <div
      className={clsx(
        props.className,
        'aspect-square animate-spin rounded-full border-2 border-current border-r-transparent',
      )}
    ></div>
  );
};
